// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Vee Validate
import VeeValidate from 'vee-validate'

import { Upload } from 'element-ui'
import VModal from 'vue-js-modal'
import VueFlashMessage from 'vue-flash-message'
import Croppa from 'vue-croppa'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import 'vue-croppa/dist/vue-croppa.css'

// Vue Form Wizard
import { FormWizard } from 'vue-form-wizard'

// My Components
import Sidebar from '@/components/Sidebar'
import Breadcrumb from '@/components/Breadcrumb'

// chat component
import Chat from 'vue-beautiful-chat'

Vue.use(Chat)
Vue.use(VeeValidate)
Vue.use(FormWizard)
Vue.use(VModal)
Vue.use(VueFlashMessage)
Vue.use(Croppa)

Vue.component('pulse-loader', PulseLoader)
Vue.component('sidebar', Sidebar)
Vue.component('breadcrumb', Breadcrumb)
Vue.component('el-upload', Upload)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js